import { TrainingsSetting } from 'generated/resources/datatable.graphql'
import { GetTrainingsSettingsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useTrainingsSettings = (companyId: string) => {
  const { loading, data, error } = useQuery(GetTrainingsSettingsDocument, {
    variables: {
      companyId: companyId,
    },
  })

  return {
    error,
    loading,
    settings: data ? data.trainings.settingsConnection.nodes : undefined,
  }
}

export type Setting = TrainingsSetting
